<app-cargador *ngIf="showLoader"></app-cargador>
<app-loader></app-loader>
<app-ventanas-modales></app-ventanas-modales>
<router-outlet></router-outlet>
